import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Data, Route, Router, RouterStateSnapshot, UrlSegment } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { map, take } from 'rxjs/operators';

import { User } from '../store';

@Injectable({ providedIn: 'root' })
export class AuthGuard  {
  constructor(private router: Router, private store: Store<{ user: User }>) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.checkUserStatus(route.data);
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.checkUserStatus(route.data);
  }

  canLoad(route: Route, segments: UrlSegment[]) {
    return this.checkUserStatus({});
  }

  checkUserStatus(data: Data) {
    return this.store.pipe(
      select(state => state.user),
      take(1),
      map(user => {
        const isExisted = user && user.userStatus === 1;

        if (isExisted) {
          if (data.noUser) {
            this.router.navigate(['/']);
            return false;
          }
        } else {
          if (!data.noUser) {
            this.router.navigate(['/passport']);
            return false;
          }
        }

        return true;
      })
    );
  }
}
